import { Fancybox } from "@fancyapps/ui";
import Faq from "./components/Faq.js";
import HeaderScroll from "./components/HeaderScroll.js";
import MobileMenu from "./components/MobileMenu.js";
import Toggle from "./components/Toggle.js";
import FooterToggle from "./components/FooterToggle.js";
import Tabs from "./components/Tabs.js";
import SmoothScroll from "./components/SmoothScroll.js";
import NumberCounter from "./components/NumberCounter.js";
import ImageGalleryVideoSlider from "../../../frontend/blocks/image-gallery-video/image-gallery-video";
import LogoGridSlider from "../../../frontend/blocks/logo-grid/logo-grid.js";
import MediaTextarea from "../../../frontend/blocks/media-textarea/media-textarea";
import Testimonials from '../../../frontend/blocks/testimonials/testimonials.js';
import PopupSearch from "./components/PopupSearch.js";
import Animate from "./components/Animate.js";
import MediaColumns from "../../../frontend/blocks/media-columns/media-columns.js";
import HeroSlider from "../../../frontend/blocks/hero-slider/hero-slider.js";
import CaseStudies from "../../../frontend/blocks/case-studies/case-studies.js";
import CaseStudyArchive from "./components/CaseStudyArchive.js";
import FormComponent from "./components/FormComponent.js";
import SearchClear from "./components/SearchClear.js";
import HomeHero from "../../../frontend/blocks/home-hero/home-hero.js";
import ToggleSubmenu from "./components/ToggleSubMenu.js";
import SkipToContent from "./components/SkipToContent.js";
import ProgramHero from "../../../frontend/blocks/program-hero/program-hero.js";
import FeaturedPrograms from "../../../frontend/blocks/featured-programs/featured-programs.js";
import WPMLSelector from "./components/WPMLSelector.js"
import EventTabs from './components/EventTabs.js';
import EventPartners from './components/EventPartners.js';
import DisableRightClick from './components/DisableRightClick.js';


{
    DisableRightClick();
}

{
    WPMLSelector();
}

{ 
    HeroSlider(); 
}

{ 
    Animate(); 
}

{
    SkipToContent();
}

{
    const eventPartners = document.querySelector('.event-partners__swiper');

    if (typeof eventPartners != "undefined" && eventPartners != null) {
        EventPartners()
    }
}

{
    const eventTabs = document.querySelector('.event-agenda__tabs');

    if (typeof eventTabs != "undefined" && eventTabs != null) {
        EventTabs()
    }
}

{
    const toggleSubMenu = document.querySelector('.header__arrow-wrap');

    if (typeof toggleSubMenu != "undefined" && toggleSubMenu != null) {
        ToggleSubmenu()
    }
}

{
    const homeHero = document.querySelector('.home-hero');

    if (typeof homeHero != "undefined" && homeHero != null) {
        HomeHero()
    }
}

{
    const formComponent = document.querySelector('.form-component');

    if (typeof formComponent != "undefined" && formComponent != null) {
        FormComponent()
    }
}

{
    
    const searchClear = document.querySelector('.search-form__field');
    if (typeof searchClear !== "undefined" && searchClear !== null) {
        SearchClear();
    }
}

{
    const caseStudyArchive = document.querySelector('.post-type-archive-case-study, .tax-case-study-category');

    if (typeof caseStudyArchive != "undefined" && caseStudyArchive != null) {
        CaseStudyArchive();
    }
}

{
    const caseStudies = document.querySelector('.case-studies');

    if (typeof caseStudies != "undefined" && caseStudies != null) {
        CaseStudies();
    }
}

{
    const numberCounter = document.querySelector(".js-count-up");
    if (typeof numberCounter != "undefined" && numberCounter != null) {
        NumberCounter();
    }
}

{
    const mediaTextarea = document.querySelector(".media-textarea__swiper");

    if (typeof mediaTextarea != "undefined" && mediaTextarea != null) {
        MediaTextarea();
    }
}

{
    const mediaColumns = document.querySelector(".media-columns__swiper");

    if (typeof mediaColumns != "undefined" && mediaColumns != null) {
        MediaColumns();
    }
}

{
    const header = document.querySelector(".header");

    if (typeof header != "undefined" && header) {
        HeaderScroll();
    }
}

{
    const faq = document.querySelector("[data-question]");

    if (typeof faq != "undefined" && faq) {
        Faq();
    }
}

{
    const mobile_menu = document.querySelector(".mobile-menu");

    if (typeof mobile_menu != "undefined" && mobile_menu) {
        MobileMenu();
    }
}

{
    const toggle_element = document.querySelector("[data-toggle]");

    if (typeof toggle_element != "undefined" && toggle_element) {
        Toggle();
    }
}

{
    const footer_toggle = document.querySelector("[data-footer-toggle]");

    if (typeof footer_toggle != "undefined" && footer_toggle) {
        FooterToggle();
    }
}

{
    const tabs = document.querySelector("[data-tabs]");

    if (typeof tabs != "undefined" && tabs != null) {
        Tabs();
    }
}

{
    const anchorLink = document.querySelector("[data-smooth-scroll]");

    if (typeof anchorLink != "undefined" && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const imageGalleryVideoSlider = document.querySelector(
        ".image-gallery-video__swiper-wrapper"
    );

    if (
        typeof imageGalleryVideoSlider != "undefined" &&
        imageGalleryVideoSlider != null
    ) {
        ImageGalleryVideoSlider(imageGalleryVideoSlider);
    }
}

{
    const logoGridSlider = document.querySelector(
        ".logo-grid__swiper-wrapper"
    );

    if (
        typeof logoGridSlider != "undefined" &&
        logoGridSlider != null
    ) {
        LogoGridSlider(logoGridSlider);
    }
}

{
    const testimonials = document.querySelector('.testimonials__swiper');
    if (typeof testimonials != "undefined" && testimonials != null) {
        Testimonials(testimonials);
    }
}

{
    const popupSearch = document.querySelector('[data-popup-search]');

    if (typeof popupSearch != "undefined" && popupSearch != null) {
        PopupSearch(popupSearch);
    }
}

{
    const programHero = document.querySelector(".program-hero");

    if (typeof programHero != "undefined" && programHero != null) {
        ProgramHero();
    }
}

{
    const featuredPrograms = document.querySelector('.featured-programs__swiper');
    if (typeof featuredPrograms != "undefined" && featuredPrograms != null) {
        FeaturedPrograms(featuredPrograms);
    }
}
